import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'coreOld/components';
import { StatusCodes } from 'coreOld/constants';
import { homePath } from 'home/routes/routePaths';

import { BoldText, ButtonWrapper, Container, Text, TextWrapper } from './errorStyle';

interface IProps {
  statusCode?: StatusCodes;
}

const getMessage = (statusCode: StatusCodes) => {
  switch (statusCode) {
    case StatusCodes.ACCESS_DENIED:
      return 'messageAccessDenied';
    case StatusCodes.NOT_FOUND:
      return 'messageNotFound';
    case StatusCodes.SERVER_ERROR:
    default:
      return 'serverError';
  }
};

const ErrorView = ({ statusCode = StatusCodes.NOT_FOUND }: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container>
      <Helmet>
        <title>{t('labelNotFound')}</title>
      </Helmet>

      <TextWrapper>
        <BoldText>{statusCode}</BoldText>
        <Text>{t(getMessage(statusCode))}</Text>

        <ButtonWrapper>
          <Button onClick={() => navigate(homePath())}>{t('buttonLabelGoToHomepage')}</Button>
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  );
};

export default ErrorView;
